const initialState = {
    ModalComponent: null,
    modalProps: {}
};
export const modalReducer = function (state = initialState, action) {
    switch (action.type) {
        case 'SHOW_MODAL':
            return {
                ModalComponent: action.ModalComponent,
                modalProps: action.modalProps
            };
        case 'CLOSE_MODAL':
            return initialState;
        default:
            return state;
    }
};
